/**
 * A traveler's gender as the airline takes it: 'male' or 'female', matching
 * the passport. Checkout offered "Other" from the first build (Sept 2025),
 * and saved travelers stored 'M'/'F', which the form copied as 'm'/'f'. An
 * airline booking needs male or female (founder, 2026-10-28: no "Other").
 *
 * Returns 'male', 'female', or '' when the value isn't one of those (the
 * form then asks for it).
 */
export function airlineGender(value) {
  const v = String(value ?? '').trim().toLowerCase();
  if (v === 'male' || v === 'm') return 'male';
  if (v === 'female' || v === 'f') return 'female';
  return '';
}

export const AIRLINE_GENDERS = Object.freeze(['male', 'female']);
